import { z } from "zod";

export const suggestedSearchSchema = z.object({
  suggested_terms: z.string().array(),
  bible_suggested_terms: z.string().array(),
});

export type SuggestedSearchSchema = z.infer<typeof suggestedSearchSchema>;
